import script from "./BaseSideBarDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseSideBarDrawer.vue?vue&type=script&setup=true&lang=js"

import "./BaseSideBarDrawer.vue?vue&type=style&index=0&id=983ce906&lang=css"

const __exports__ = script;

export default __exports__